import { render, staticRenderFns } from "./admin-categories.vue?vue&type=template&id=282e5ed6&scoped=true"
import script from "./admin-categories.vue?vue&type=script&lang=js"
export * from "./admin-categories.vue?vue&type=script&lang=js"
import style0 from "./admin-categories.vue?vue&type=style&index=0&id=282e5ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e5ed6",
  null
  
)

export default component.exports